// src/pages/Landing.js
import React from "react";
import { Link } from "react-router-dom";

export default function Landing() {
  return (
    <div className="landing-page">
      {/* HERO */}
      <section className="landing-hero">
        <div className="landing-hero-content">
          <img
            src="/logo192.png"
            alt="ReflectRise"
            className="landing-logo"
          />

          <h1>ReflectRise</h1>
          <p className="landing-subtitle">
            Plan your days. Build habits. Reflect on your growth.
          </p>

          <div className="landing-actions">
            <Link to="/login" className="btn primary">
              Get Started
            </Link>
            <Link to="/login" className="btn secondary">
              Log In
            </Link>
          </div>
        </div>
      </section>

      {/* FEATURES */}
      <section className="landing-features">
        <div className="feature-card">
          <h3>🗓 Planner</h3>
          <p>
            Organise your day, week, and month with reliable saving, editing,
            and deletion.
          </p>
        </div>

        <div className="feature-card">
          <h3>📓 Journal</h3>
          <p>
            Capture daily thoughts and reflect on your progress over time.
          </p>
        </div>

        <div className="feature-card">
          <h3>🎯 Goals & Streaks</h3>
          <p>
            Stay consistent with goals, streak tracking, and achievements.
          </p>
        </div>

        <div className="feature-card">
          <h3>🎨 Custom Themes</h3>
          <p>
            Personalise your experience with premium themes and colour palettes.
          </p>
        </div>
      </section>

      {/* CTA */}
      <section className="landing-cta">
        <h2>Start improving your life today</h2>
        <p>
          ReflectRise helps you stay intentional, organised, and motivated.
        </p>

        <Link to="/login" className="btn primary large">
          Create Free Account
        </Link>
      </section>

{/* FOOTER */}
<footer className="landing-footer">
  <p>© {new Date().getFullYear()} ReflectRise. All rights reserved.</p>

  <div className="landing-footer-links">
    <Link to="/about">About</Link>

    <a
      href="https://reflectrise.github.io/reflectrise-privacy-policy/"
      target="_blank"
      rel="noopener noreferrer"
    >
      Policies
    </a>
  </div>
</footer>

    </div>
  );
}
